import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';
import { Message } from 'primeng/primeng';

import { NotificationsService } from '../../services/notification.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
    msgs: Message[] = [];
    subscription: Subscription;

    constructor(private notificationsService: NotificationsService) { }

    ngOnInit() {
        this.subscribeToNotifications();
    }

    subscribeToNotifications() {
        this.subscription = this.notificationsService.notificationChange
            .subscribe(notification => {
                this.msgs.push(notification);
                setTimeout(
                    () => this.deleteNotification(notification), this.getNotificationDisplayInterval(notification)
                );
            });
    }

    clear() {
        this.msgs = [];
    }

    deleteOlderNotification() {
        if (this.msgs.length > 0) {
            this.msgs.shift();
            return;
        }

        this.msgs = [];
    }

    deleteNotification(notification) {
        if (this.msgs.length > 0) {
            const index = this.msgs.indexOf(notification);
            if (index >= 0) {
                this.msgs.splice(index, 1);
            }
            return;
        }

        this.msgs = [];
    }

    ngOnDestroy() {
        this.msgs = [];

        this.notificationsService.notificationChange.next();
        this.notificationsService.notificationChange.complete();
        this.notificationsService.notificationChange.unsubscribe();
        this.notificationsService.notificationChange = null;

        this.subscription.unsubscribe();
        this.subscription = null;
    }

    getNotificationDisplayInterval(notification) {
        let displayInterval = 5;

        switch (notification.severity) {
            case 'error': {
                displayInterval = environment.notifications_error_display_intervals_in_seconds;
                break;
            }
            case 'success': {
                displayInterval = environment.notifications_success_display_interval_in_seconds;
                break;
            }
            case 'info': {
                displayInterval = environment.notifications_info_display_interval_in_seconds;
                break;
            }
            case 'warn': {
                displayInterval = environment.notificatios_warn_display_interval_in_seconds;
                break;
            }
        }

        return displayInterval * 1000;
    }
}
